<template>
  <div class="home-page-wrap" :class="{ 'h5-home-page-wrap': isH5 }">
    <!-- 公告 -->
    <Notice
      v-if="layout.affiche && layout.affiche.length"
      :noticeList="layout.affiche"
    />
    <!-- 课程分类tab -->
    <ClassifyTabs
      ref="classifyTabs"
      :activeTabId="activeTabId"
      :tabList="tabList"
      :bannerList="layout.banner"
      @openDrawer="handleOpenDrawer"
      @changeTab="handleChangeTab"
    />
    <!-- banner -->
    <Banner
      v-if="activeTabId === 0 && layout.banner && layout.banner.length"
      :bannerList="layout.banner || []"
    />
    <div
      v-if="activeTabId === 0"
      class="content home-content"
      :class="{
        'electron-home-content': isElectron,
      }"
    >
      <!-- 分类 -->
      <CourseCategories v-if="!isH5" />
      <!-- 精品课程 -->
      <Courses
        v-if="layout.course && layout.course.length"
        :couseList="layout.course"
      />
      <!-- 推荐机构 -->
      <OrgList v-if="layout.org && layout.org.length" :orgList="layout.org" />
    </div>
    <!-- 课程分类列表 -->
    <CategoryCourseList v-else :categoryId="activeTabId" />
    <!-- 课程分类弹窗 -->
    <ClassifyDrawer ref="classifyDrawer" @saveCategory="handleSaveCategory" />
    <!-- 入驻卡片 -->
    <DownloadCard v-if="activeTabId === 0 && !isElectron && !isH5" />
  </div>
</template>

<script>
import DownloadCard from "./components/DownloadCard.vue";
import { mapGetters } from "vuex";
import { getCategoryList } from "@saas/server-api/src/category";
import CategoryCourseList from "./CategoryCourseList";
import ClassifyDrawer from "./components/ClassifyDrawer.vue";
import ClassifyTabs from "./components/ClassifyTabs";
import { getHomepage } from "@saas/server-api/src/layout";
import { getCourseState } from "@saas/server-api/src/course";
import CourseCategories from "./components/CourseCategories";
import OrgList from "./components/OrgList";
import Courses from "./components/Courses";
import Banner from "./components/Banner.vue";
import Notice from "./components/Notice.vue";
import { isH5 } from "@saas/components";
export default {
  data: function () {
    return {
      isH5: isH5(),
      isElectron: false,
      layout: {},
      activeTabId: 0,
      tabList: [
        {
          id: 0,
          category_name: "推荐",
        },
      ],
    };
  },
  mounted() {
    this.isElectron = window.isElectron;
    this.apiGetCategoryList();
    // if (this.$route.query.vconsole) {
    //   var vConsole = new window.VConsole();
    // }
  },
  methods: {
    // 分类
    apiGetCategoryList(type) {
      getCategoryList().then((res) => {
        if (res.code === 1) {
          this.tabList = [
            {
              id: 0,
              category_name: "推荐",
            },
          ];
          // if (this.isAuthenticated || type === "save") {
          //   localStorage.setItem("AuthTabList", JSON.stringify(res.data || []));
          //   this.tabList = this.tabList.concat(res.data || []);
          // } else {
          //   let tabList = JSON.parse(localStorage.getItem("AuthTabList"));
          //   if (tabList) {
          //     this.tabList = this.tabList.concat(tabList);
          //   } else {
          //     this.tabList = this.tabList.concat(res.data || []);
          //   }
          // }
          this.tabList = this.tabList.concat(res.data || []);
          let obj = {};
          // 去重
          this.tabList = this.tabList.reduce((item, next) => {
            obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
            return item;
          }, []);
          if (type === "save") {
            if (res?.data?.length) {
              this.handleChangeTab(res.data[0]?.id || 0);
            }
            this.$refs.classifyTabs.handleOperateBtn();
          } else {
            // 页面加载时从sessionStorage读取activeTabId的值
            const activeTabId = sessionStorage.getItem("activeTabId");
            if (activeTabId !== null) {
              let index = this.tabList.findIndex((item) => {
                return item.id === parseInt(activeTabId);
              });
              if (index !== -1) {
                this.activeTabId = parseInt(activeTabId);
              } else {
                this.activeTabId = 0;
              }
              setTimeout(() => {
                this.$refs.classifyTabs.scrollActiveTab(this.activeTabId);
              }, 100);
            }
            this.apiGetHomepage();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSaveCategory() {
      this.apiGetCategoryList("save");
    },
    handleChangeTab(id) {
      this.activeTabId = id;
      this.$refs.classifyTabs.scrollActiveTab(id);
      sessionStorage.setItem("activeTabId", id);
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      }
      if (document.documentElement.scrollTop) {
        document.documentElement.scrollTop = 0;
      }
      if (document.getElementById("electron-main")) {
        document.getElementById("electron-main").scrollTop = 0;
      }
      if (id === 0) {
        this.apiGetHomepage();
      }
    },
    handleOpenDrawer() {
      if (this.$refs.classifyDrawer) {
        this.$refs.classifyDrawer.openDrawer();
      }
    },
    apiGetHomepage() {
      let params = {};
      if (this.$route.query.preview) {
        params.preview = 1;
      }
      getHomepage(params).then((res) => {
        if (res.code === 1) {
          this.layout = res.data || {};
          let courseIds = []; //首页推荐展示课程ids
          let courseList = []; //首页推荐展示课程信息汇总
          // 精品课
          if (this.layout?.course?.length) {
            this.layout.course.forEach((course, index) => {
              this.layout.course[index] = {
                ...course,
                ...course.course_info,
                // 添加模块标识
                moduleName: "course",
                index,
              };
              if (course?.course_info.id) {
                courseIds.push(course?.course_info.id);
                courseList.push(this.layout.course[index]);
              }
            });
          }
          // 推荐机构
          if (this.layout?.org?.length) {
            this.layout.org.forEach((org, index) => {
              if (org?.course_list?.length) {
                // 添加模块标识
                org.course_list[0].moduleName = "org";
                org.course_list[0].index = index;
                courseIds.push(org?.course_list[0].id);
                courseList.push(org.course_list[0]);
              }
            });
          }
          if (courseIds?.length) {
            // 获取课程状态
            getCourseState({
              course_id: courseIds.join(","),
            }).then((res) => {
              if (res.code === 1 && res.data?.length) {
                let haveStatusIds = res.data.map((item) => item.course_id);
                courseList.forEach((course) => {
                  if (haveStatusIds.includes(course.id)) {
                    let { trial_state, live_state } = res.data.find(
                      (element) => element.course_id === course.id
                    );
                    let { moduleName, index } = course;
                    if (moduleName === "org") {
                      this.$set(this.layout[moduleName][index], "course_list", [
                        {
                          ...course,
                          trial_state,
                          live_state,
                        },
                      ]);
                    } else {
                      this.$set(this.layout[moduleName], index, {
                        ...course,
                        trial_state,
                        live_state,
                      });
                    }
                  }
                });
              }
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  watch: {},
  components: {
    CourseCategories,
    OrgList,
    Courses,
    Notice,
    Banner,
    ClassifyDrawer,
    ClassifyTabs,
    CategoryCourseList,
    DownloadCard,
  },
};
</script>

<style lang="scss" scoped>
.home-page-wrap {
  position: relative;
  background: #fff;
  width: 100%;
  min-height: calc(100vh - 50px);
  min-width: 1200px;
  .home-content {
    background: transparent;
  }
  .electron-home-content {
    width: 980px;
  }
}

// h5样式
.home-page-wrap.h5-home-page-wrap {
  min-width: 100%;
  max-width: 100%;
  background: #f5f5f6;
  .home-content {
    width: 100%;
  }
}
</style>
<style lang="scss">
.home-page-wrap {
  .module-title {
    font-weight: 600;
    font-size: 40px;
    color: $saas-text-color;
    line-height: 56px;
    margin-bottom: 34px;
  }
  .electron-home-content {
    .module-title {
      font-weight: 600;
      font-size: 18px;
      color: $saas-text-color;
      line-height: 25px;
      margin-bottom: 12px;
    }
  }
}

// h5样式
.home-page-wrap.h5-home-page-wrap {
  .module-title {
    font-weight: 500;
    font-size: 0.43rem;
    color: #0d1400;
    line-height: 0.6rem;
    margin-bottom: 0.21rem;
  }
}
</style>
